<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('protocolsettings.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="protocol.name" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('protocolsettings.form.fields.metodo.label')"
            label-for="input-classe"
            :description="$t('protocolsettings.form.fields.metodo.description')"
        >
          <b-form-input id="input-classe" v-model="protocol.request_method" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('protocolsettings.form.fields.ordem_url.label')"
            label-for="input-classe"
            :description="$t('protocolsettings.form.fields.ordem_url.description')"
        >
          <b-form-input id="input-classe" v-model="protocol.order_verifier_url" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('protocolsettings.form.fields.resultado_url.label')"
            label-for="input-classe"
            :description="$t('protocolsettings.form.fields.resultado_url.description')"
        >
          <b-form-input id="input-classe" v-model="protocol.support_observation_verifier_url" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('protocolsettings.form.fields.busca_resultado_url.label')"
            label-for="input-classe"
            :description="$t('protocolsettings.form.fields.busca_resultado_url.description')"
        >
          <b-form-input id="input-classe" v-model="protocol.support_observation_endpoint" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('protocolsettings.form.fields.tipo_conteudo.label')"
            label-for="input-classe"
            :description="$t('protocolsettings.form.fields.tipo_conteudo.description')"
        >
          <b-form-input id="input-classe" v-model="protocol.content_type" type="text"/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('protocolsettings.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ProtocolRepository from '@/repositories/vns/ProtocolSettingRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      protocol: 'protocolSettings/current',
      isLoading: 'protocolSettings/isLoading'
    }),
    pageTitle() {
      if (this.protocol_id) return this.$t('protocolsettings.form.titulo_pagina.editar')
      return this.$t('protocolsettings.form.titulo_pagina.criar')
    }
  },
  data() {
    return {
      protocol_id: null
    }
  },
  methods: {
    ...mapActions([
      'protocolSettings/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      ProtocolRepository.post(this.protocol).then(() => {
        this.$snotify.success(this.$t('protocolsettings.form.create.success'))
        this.$router.push({name: 'vns.protocol_settings'})
      }).catch(error => {
        this.$snotify.error(this.$t('protocolsettings.form.create.error'))
        if (error.response.status === 422) {
          ProtocolRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      ProtocolRepository.put(this.protocol_id, this.protocol).then(() => {
        this.$snotify.success(this.$t('protocolsettings.form.update.success'))
        this.$router.push({name: 'vns.protocol_settings'})
      }).catch(error => {
        this.$snotify.error(this.$t('protocolsettings.form.update.error'))
        if (error.response.status === 422) {
          ProtocolRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('protocolSettings/setCurrent', {})
    if (this.$route.params.id) {
      this.protocol_id = this.$route.params.id
      await this['protocolSettings/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
